import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ReferralEditBody from "../components/EditData/ReferralEditBody";
import ReferralEditTitle from "../components/EditData/ReferralEditTitle";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import dayjs from "dayjs";
import apiClient from "../libraries/ApiClient";

import "react-toastify/dist/ReactToastify.css";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-height: calc(100% - 50px);
`;

function ReferralEditData({ lineUserId }) {
  const navigate = useNavigate();
  const [dataFromBody, setDataFromBody] = useState(null);
  const [sendBasicData, setSendBasicData] = useState(null);
  const [sendOperativeData, setSendOperativeData] = useState(null);
  const [sendMediaData, setSendMediaData] = useState(null);
  const [sendPreoperativeMediaData, setSendPreoperativeMediaData] =
    useState(null);
  const [sendPostoperativeMediaData, setSendPostoperativeMediaData] =
    useState(null);
  const [sendPdfData, setSendPdfData] = useState(null);
  const [detailData, setDetailData] = useState(null);

  //console.log(sendPreoperativeMediaData);
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);
  if (dataFromBody?.Code === "1") {
    return <h1>找不到您查詢的資料</h1>;
  }
  return (
    <Container>
      <ReferralEditTitle
        dataFromBody={dataFromBody}
        sendBasicData={sendBasicData}
        sendOperativeData={sendOperativeData}
        sendMediaData={sendMediaData}
        sendPreoperativeMediaData={sendPreoperativeMediaData}
        sendPostoperativeMediaData={sendPostoperativeMediaData}
        sendPdfData={sendPdfData}
        detailData={detailData}
      />
      <ToastContainer enableMultiContainer limit={1} containerId={"success1"} />
      <ReferralEditBody
        setDataFromBody={setDataFromBody}
        setSendBasicData={setSendBasicData}
        setSendOperativeData={setSendOperativeData}
        setSendMediaData={setSendMediaData}
        setSendPreoperativeMediaData={setSendPreoperativeMediaData}
        setSendPostoperativeMediaData={setSendPostoperativeMediaData}
        setSendPdfData={setSendPdfData}
        setDetailData={setDetailData}
      />
    </Container>
  );
}

export default ReferralEditData;
